module.exports = __webpack_public_path__ + "media/assets/images/rw-modal-00-cf24796de7516d58d14b740e1b6b1ff7.jpg";